<script>
export default {
    name: "Subscrtiptions",
    methods: {
        goGta5() {
            this.$router.push('/subscribe?game=gta5&period=3m&tier=1')
        },
        goPremium() {
            this.$router.push('/subscribe?game=all&period=3m&tier=2')
            //this.$router.push('/signin')
        },
    }
}
</script>

<template>
    <section class="subscriptions">
        <h2>{{__('Ещё лучше — с подпиской')}}</h2>
        <div class="subs-container">
            <div class="subs-card plus">
                <div class="subs-text-container">
                    <div class="subs-title-container">
                        <div class="subs-title">Cloud Mods</div>
                        <div class="subs-price">{{__('Бесплатно')}}</div>
                    </div>
                    <div class="subs-benefits-container">
                        <div class="subs-benefit">
                            <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.68086 15.7348C5.36211 15.7447 5.03203 15.5776 4.83086 15.3098L1.64336 11.0598C1.29061 10.5895 1.38694 9.92364 1.85586 9.5723C2.32761 9.22097 2.99203 9.31589 3.34336 9.7848L5.68369 12.9057L13.6595 2.33313C14.0137 1.86422 14.6795 1.77213 15.147 2.12488C15.6159 2.47905 15.708 3.14488 15.3553 3.61239L6.52944 15.3112C6.32828 15.5776 6.01519 15.7348 5.68086 15.7348Z" fill="#848484"/>
                            </svg>
                            {{__('Доступ к 200+ модификаций')}}
                        </div>
                        <div class="subs-benefit">
                            <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.68086 15.7348C5.36211 15.7447 5.03203 15.5776 4.83086 15.3098L1.64336 11.0598C1.29061 10.5895 1.38694 9.92364 1.85586 9.5723C2.32761 9.22097 2.99203 9.31589 3.34336 9.7848L5.68369 12.9057L13.6595 2.33313C14.0137 1.86422 14.6795 1.77213 15.147 2.12488C15.6159 2.47905 15.708 3.14488 15.3553 3.61239L6.52944 15.3112C6.32828 15.5776 6.01519 15.7348 5.68086 15.7348Z" fill="#848484"/>
                            </svg>
                            {{__('Бесплатная оптимизация')}}
                        </div>
                        <div class="subs-benefit">
                            <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.68086 15.7348C5.36211 15.7447 5.03203 15.5776 4.83086 15.3098L1.64336 11.0598C1.29061 10.5895 1.38694 9.92364 1.85586 9.5723C2.32761 9.22097 2.99203 9.31589 3.34336 9.7848L5.68369 12.9057L13.6595 2.33313C14.0137 1.86422 14.6795 1.77213 15.147 2.12488C15.6159 2.47905 15.708 3.14488 15.3553 3.61239L6.52944 15.3112C6.32828 15.5776 6.01519 15.7348 5.68086 15.7348Z" fill="#848484"/>
                            </svg>
                            {{__('Отсутствие рекламы')}}
                        </div>
                    </div>
                </div>
                <a href="/CloudModsSetup.exe" download class="subs-button-plus">
                    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.41667 15.5C3.80556 15.5 3.30903 15.2674 2.92709 14.8021C2.54514 14.3368 2.40972 13.8056 2.52084 13.2083L3.70834 7.02083C3.81945 6.4375 4.10313 5.95486 4.55938 5.57292C5.01563 5.19097 5.55139 5 6.16667 5H14.8333C15.4486 5 15.9844 5.19097 16.4406 5.57292C16.8969 5.95486 17.1806 6.44444 17.2917 7.04167L18.4792 13.2292C18.5903 13.8264 18.4514 14.3542 18.0625 14.8125C17.6736 15.2708 17.1736 15.5 16.5625 15.5C16.3403 15.5 16.125 15.4688 15.9167 15.4063C15.7083 15.3438 15.5278 15.2361 15.375 15.0833L13.3958 13.5H7.60417L5.625 15.0833C5.47222 15.2361 5.2882 15.3438 5.07292 15.4063C4.85764 15.4688 4.63889 15.5 4.41667 15.5ZM14.2456 11C14.4569 11 14.6354 10.9285 14.7813 10.7856C14.9271 10.6427 15 10.4656 15 10.2544C15 10.0431 14.9285 9.86458 14.7856 9.71875C14.6427 9.57292 14.4656 9.5 14.2544 9.5C14.0431 9.5 13.8646 9.57146 13.7188 9.71437C13.5729 9.85729 13.5 10.0344 13.5 10.2456C13.5 10.4569 13.5715 10.6354 13.7144 10.7813C13.8573 10.9271 14.0344 11 14.2456 11ZM12.7456 9C12.9569 9 13.1354 8.92854 13.2813 8.78563C13.4271 8.64271 13.5 8.46563 13.5 8.25438C13.5 8.04313 13.4285 7.86458 13.2856 7.71875C13.1427 7.57292 12.9656 7.5 12.7544 7.5C12.5431 7.5 12.3646 7.57146 12.2188 7.71437C12.0729 7.85729 12 8.03437 12 8.24562C12 8.45687 12.0715 8.63542 12.2144 8.78125C12.3573 8.92708 12.5344 9 12.7456 9ZM7.5 9.75V10.5C7.5 10.6389 7.54861 10.7569 7.64584 10.8542C7.74306 10.9514 7.86111 11 8 11C8.13889 11 8.25695 10.9514 8.35417 10.8542C8.45139 10.7569 8.5 10.6389 8.5 10.5V9.75H9.25C9.38889 9.75 9.50695 9.70139 9.60417 9.60417C9.70139 9.50694 9.75 9.38889 9.75 9.25C9.75 9.11111 9.70139 8.99306 9.60417 8.89583C9.50695 8.79861 9.38889 8.75 9.25 8.75H8.5V8C8.5 7.86111 8.45139 7.74306 8.35417 7.64583C8.25695 7.54861 8.13889 7.5 8 7.5C7.86111 7.5 7.74306 7.54861 7.64584 7.64583C7.54861 7.74306 7.5 7.86111 7.5 8V8.75H6.75C6.61111 8.75 6.49306 8.79861 6.39584 8.89583C6.29861 8.99306 6.25 9.11111 6.25 9.25C6.25 9.38889 6.29861 9.50694 6.39584 9.60417C6.49306 9.70139 6.61111 9.75 6.75 9.75H7.5Z" fill="white"/>
                    </svg>
                    {{__('Скачать бесплатно')}}
                </a>
            </div>
            <div class="subs-card premium">
                <div class="subs-text-container">
                    <div class="subs-title-container">
                        <div class="subs-title">Cloud Premium</div>
                        <div class="subs-price">{{__('399₽/')}}{{__('мес.')}}</div>
                    </div>
                    <div class="subs-benefits-container">
                        <div class="subs-benefit">
                            <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.68086 15.7348C5.36211 15.7447 5.03203 15.5776 4.83086 15.3098L1.64336 11.0598C1.29061 10.5895 1.38694 9.92364 1.85586 9.5723C2.32761 9.22097 2.99203 9.31589 3.34336 9.7848L5.68369 12.9057L13.6595 2.33313C14.0137 1.86422 14.6795 1.77213 15.147 2.12488C15.6159 2.47905 15.708 3.14488 15.3553 3.61239L6.52944 15.3112C6.32828 15.5776 6.01519 15.7348 5.68086 15.7348Z" fill="#848484"/>
                            </svg>
                            {{__('Доступ ко всем модификациям')}}
                        </div>
                        <div class="subs-benefit">
                            <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.68086 15.7348C5.36211 15.7447 5.03203 15.5776 4.83086 15.3098L1.64336 11.0598C1.29061 10.5895 1.38694 9.92364 1.85586 9.5723C2.32761 9.22097 2.99203 9.31589 3.34336 9.7848L5.68369 12.9057L13.6595 2.33313C14.0137 1.86422 14.6795 1.77213 15.147 2.12488C15.6159 2.47905 15.708 3.14488 15.3553 3.61239L6.52944 15.3112C6.32828 15.5776 6.01519 15.7348 5.68086 15.7348Z" fill="#848484"/>
                            </svg>
                            {{__('Ускоренная загрузка файлов')}}
                        </div>
                        <div class="subs-benefit">
                            <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.68086 15.7348C5.36211 15.7447 5.03203 15.5776 4.83086 15.3098L1.64336 11.0598C1.29061 10.5895 1.38694 9.92364 1.85586 9.5723C2.32761 9.22097 2.99203 9.31589 3.34336 9.7848L5.68369 12.9057L13.6595 2.33313C14.0137 1.86422 14.6795 1.77213 15.147 2.12488C15.6159 2.47905 15.708 3.14488 15.3553 3.61239L6.52944 15.3112C6.32828 15.5776 6.01519 15.7348 5.68086 15.7348Z" fill="#848484"/>
                            </svg>
                            {{__('Значок Premium подписчика')}}
                        </div>
                        <div class="subs-benefit">
                            <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.68086 15.7348C5.36211 15.7447 5.03203 15.5776 4.83086 15.3098L1.64336 11.0598C1.29061 10.5895 1.38694 9.92364 1.85586 9.5723C2.32761 9.22097 2.99203 9.31589 3.34336 9.7848L5.68369 12.9057L13.6595 2.33313C14.0137 1.86422 14.6795 1.77213 15.147 2.12488C15.6159 2.47905 15.708 3.14488 15.3553 3.61239L6.52944 15.3112C6.32828 15.5776 6.01519 15.7348 5.68086 15.7348Z" fill="#848484"/>
                            </svg>
                            {{__('Роль в нашем Discord-сервере')}}
                        </div>
                        <div class="subs-benefit">
                            <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.68086 15.7348C5.36211 15.7447 5.03203 15.5776 4.83086 15.3098L1.64336 11.0598C1.29061 10.5895 1.38694 9.92364 1.85586 9.5723C2.32761 9.22097 2.99203 9.31589 3.34336 9.7848L5.68369 12.9057L13.6595 2.33313C14.0137 1.86422 14.6795 1.77213 15.147 2.12488C15.6159 2.47905 15.708 3.14488 15.3553 3.61239L6.52944 15.3112C6.32828 15.5776 6.01519 15.7348 5.68086 15.7348Z" fill="#848484"/>
                            </svg>
                            {{__('Миллион уважения от разработчиков')}}
                        </div>
                    </div>
                </div>
                <div class="subs-button-premium" @click="goPremium()">
                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10 4.5C10.2424 4.5 10.469 4.61986 10.604 4.81962L13.3531 8.8859L16.7289 5.11477C16.9465 4.87173 17.301 4.80304 17.5947 4.94697C17.8886 5.0909 18.049 5.41197 17.9867 5.73106L16.0331 15.7336C15.9784 16.0136 15.8708 16.2722 15.7217 16.5C14.671 14.7161 12.4111 13.4822 9.79269 13.4822C7.3504 13.4822 5.22002 14.5557 4.09187 16.1476C4.03724 16.0162 3.99506 15.8777 3.96692 15.7336L2.01333 5.73106C1.95101 5.41197 2.11148 5.0909 2.40526 4.94697C2.69903 4.80304 3.05356 4.87173 3.27113 5.11477L6.64689 8.8859L9.39603 4.81962C9.53109 4.61986 9.75756 4.5 10 4.5Z" fill="white"/>
                    </svg>
                    {{__('Подписаться на Premium')}}
                </div>
            </div>
        </div>
    </section>
</template>

<style scoped>
.subscriptions {
        width: 100%;

        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        background-repeat: no-repeat;
        background-position: center;
}

.subs-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
}

.subs-card {
    position: relative;
    border: 1px solid #202020;
}

.subs-text-container {
    display: flex;
    flex-direction: column;
}

.subs-title {
    font-style: normal;
    font-weight: 700;
    color: var(--text-primary);
}

.subs-price {
    font-style: normal;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.70);
}

.subs-benefits-container {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
}

.subs-benefit {
    color: var(--text-secondary);
    font-style: normal;
    font-weight: 600;

    display: flex;
    align-items: center;
    justify-content: center;
}

.subs-button-plus, .subs-button-premium {
    position: absolute;

    display: flex;
    justify-content: center;
    align-items: center;

    transition: 0.25s ease;
}

.subs-button-plus {
    background: var(--button-main);
}

.subs-button-premium {
    background: var(--color-main);
}

.subs-button-plus:hover {
    cursor: pointer;
    background: var(--button-main-hover);
}

.subs-button-premium:hover {
    cursor: pointer;
    background: #593FB9;
}

@media (min-width: 320px) {
    .subscriptions {
        height: 206.25vw;
        gap: 5vw;
    }

    .subs-container {
        flex-direction: column;
        gap: 3.125vw;
    }

    .subs-card {
        width: 90vw;
        height: 86.5625vw;
        border-radius: 3.75vw;
    }

    .subs-card.plus {
        background-size: contain;
        background-repeat: no-repeat;
        background-image: url("@/assets/images/subs/game_plus.png");
    }

    .subs-card.premium {
        background-size: contain;
        background-repeat: no-repeat;
        background-image: url("@/assets/images/subs/cloud_premium.png");
    }

    .subs-text-container {
        position: absolute;
        top: 6.25vw;
        left: 6.25vw;

        gap: 5vw;
    }

    .subs-title {
        font-size: 5.625vw;
    }

    .subs-price {
        font-size: 5vw;
    }

    .subs-benefits-container {
        gap: 3.125vw;
    }

    .subs-benefit {
        gap: 1.875vw;
        font-size: 3.75vw;
    }

    .subs-button-plus, .subs-button-premium {
        width: 77.5vw;
        height: 13.4375vw;
        border-radius: 3.125vw;
        gap: 2.5vw;

        bottom: 6.25vw;
        left: 6.25vw;
    }
}

@media (min-width: 464px) {
    .subscriptions {
        height: 730px;
        gap: 16px;
    }

    .subs-container {
        flex-direction: column;
        gap: 12px;
    }

    .subs-card {
        width: 464px;
        height: 315px;
        border-radius: 12px;
    }

    .subs-card.plus {
        background-size: contain;
        background-image: url("@/assets/images/subs/game_plus.png");
    }

    .subs-card.premium {
        background-size: contain;
        background-image: url("@/assets/images/subs/cloud_premium.png");
    }


    .subs-text-container {
        position: absolute;
        top: 24px;
        left: 24px;

        gap: 16px;
    }

    .subs-title {
        font-size: 20px;
    }

    .subs-price {
        font-size: 16px;
    }

    .subs-benefits-container {
        gap: 12px;
    }

    .subs-benefit {
        gap: 8px;
        font-size: 14px;
    }

    .subs-button-plus, .subs-button-premium {
        width: 416px;
        height: 44px;
        border-radius: 12px;
        gap: 10px;

        bottom: 24px;
        left: 24px;
    }
}

@media (min-width: 744px) {
    .subscriptions {
        height: 458px;
        gap: 24px;
    }

    .subs-container {
        flex-direction: row;
        gap: 12px;
    }

    .subs-card {
        width: 366px;
        height: 347px;
        border-radius: 12px;
    }

    .subs-card.plus {
        background-size: contain;
        background-image: url("@/assets/images/subs/game_plus.png");
    }

    .subs-card.premium {
        background-size: contain;
        background-image: url("@/assets/images/subs/cloud_premium.png");
    }

    .subs-text-container {
        position: absolute;
        top: 32px;
        left: 32px;

        gap: 16px;
    }

    .subs-title {
        font-size: 22px;
    }

    .subs-price {
        font-size: 18px;
    }

    .subs-benefits-container {
        gap: 12px;
    }

    .subs-benefit {
        gap: 8px;
        font-size: 16px;
    }

    .subs-button-plus, .subs-button-premium {
        width: 302px;
        height: 44px;
        border-radius: 12px;
        gap: 10px;

        bottom: 32px;
        left: 32px;
    }
}

@media (min-width: 984px) {
    .subscriptions {
        height: 472px;
        gap: 24px;
    }

    .subs-container {
        gap: 12px;
    }

    .subs-card {
        width: 486px;
        height: 350px;
        border-radius: 12px;
    }

    .subs-card.plus {
        background-size: contain;
        background-image: url("@/assets/images/subs/game_plus.png");
    }

    .subs-card.premium {
        background-size: contain;
        background-image: url("@/assets/images/subs/cloud_premium.png");
    }


    .subs-text-container {
        position: absolute;
        top: 32px;
        left: 32px;

        gap: 16px;
    }

    .subs-title {
        font-size: 22px;
    }

    .subs-price {
        font-size: 18px;
    }

    .subs-benefits-container {
        gap: 12px;
    }

    .subs-benefit {
        gap: 8px;
        font-size: 16px;
    }

    .subs-button-plus, .subs-button-premium {
        width: 422px;
        height: 47px;
        border-radius: 12px;
        gap: 10px;

        bottom: 32px;
        left: 32px;
    }
}

@media (min-width: 1248px) {
    .subscriptions {
        height: 564px;
        gap: 32px;
    }

    .subs-container {
        gap: 12px;
    }

    .subs-card {
        width: 618px;
        height: 374px;
        border-radius: 12px;
    }

    .subs-card.plus {
        background-size: contain;
        background-image: url("@/assets/images/subs/game_plus.png");
    }

    .subs-card.premium {
        background-size: contain;
        background-image: url("@/assets/images/subs/cloud_premium.png");
    }

    .subs-text-container {
        position: absolute;
        top: 40px;
        left: 40px;

        gap: 16px;
    }

    .subs-title {
        font-size: 24px;
    }

    .subs-price {
        font-size: 20px;
    }

    .subs-benefits-container {
        gap: 12px;
    }

    .subs-benefit {
        gap: 8px;
        font-size: 16px;
    }

    .subs-button-plus, .subs-button-premium {
        width: 538px;
        height: 47px;
        border-radius: 12px;
        gap: 10px;

        bottom: 40px;
        left: 40px;
    }
}
</style>